import * as Sentry from '@sentry/react';
import { onUploadSubmit } from 'components/exams/Dropzone/dropzone.api';
import { renameFile } from 'components/exams/utils';
import { predictionsRequest } from 'components/pages/CreateExam/ExamPanel/FilterTab/filterTab.api';
import { ExamStatus } from 'constants/exams';
import { TECHNOLOGIES_BY_GROUP, TECHNOLOGY_MODELS } from 'constants/products';
import { TOperationProps } from 'types/apollo-types';
import { ExamObject, UserObject } from 'types/mongoose-types';
import { Technology } from 'utils/products';
import { v4 as uuidv4 } from 'uuid';

export const handleUploadSubmit = async (
  values: { files: File[] },
  exam: ExamObject,
  updateExam: TOperationProps,
) => {
  const institutionId = (exam.user as UserObject)?.institution?._id.toString();

  // # PRE PROCESSING
  let files: File[];
  if (Technology.isAvailable(TECHNOLOGIES_BY_GROUP.detection)) {
    // # Rename files with index to be able to maintain order in the future
    files = values.files.map((file, index) => {
      return renameFile(file, `${index}`);
    });
  } else {
    // # Rename files with an uuid - universally unique identifier with 36 characters
    // # Original name has no value and may contain PII or other sensitive information
    files = values.files.map((file) => {
      const uuid = uuidv4();
      return renameFile(file, uuid);
    });
  }

  await onUploadSubmit({
    files,
    examId: exam._id.toString(),
    institutionId,
  }).then(async () => {
    const msg = `New file uploaded for exam: ${exam?._id.toString() ?? ''}`;
    Sentry.captureMessage(msg);

    // # POST PROCESSING
    let fullVideo;
    let frames;
    if (Technology.isAvailable(TECHNOLOGIES_BY_GROUP.detection)) {
      frames = files.map((file) => file.name);
    } else {
      // ignore current file extension and transform filename to mp4
      const currentfileName = files[0].name.split('.')[0];
      fullVideo = currentfileName + '.mp4';
    }

    await updateExam({
      variables: {
        updateExamId: exam?._id,
        updateExamRecord: {
          media: {
            fullVideo,
            frames,
          },
          status: ExamStatus.UnderAnalysis,
        },
      },
    });

    const modelId = TECHNOLOGY_MODELS[Technology.availableTechnology];

    await predictionsRequest.post(
      '/predict',
      { data: { cleansing: 'none' } },
      {
        headers: {
          'Content-Type': 'application/json',
          'Exam-Id': exam._id.toString(),
          'Institution-Id': institutionId,
          'Model-Id': modelId,
        },
      },
    );
  });
};
